import React from "react";

import type { ScoreKey } from "~/sdks/LocalContent/types";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useRootElement } from "../context";

import { Header } from "./Header";
import { Content } from "./Content";

import * as styles from "./styles";

export function Score({
  scoreKey,
  backgroundColor,
  fillColor,
}: {
  scoreKey: ScoreKey;
  backgroundColor?: string;
  fillColor?: string;
}) {
  const {
    isMarkersLoading,
    scoresData,
    activeScore,
    activeScoreData,
    markersData,
    onSelectScore,
  } = useRootElement();
  const tracking = useTracking();

  const handleOnSelectScore = (score: ScoreKey) => () => {
    if (typeof onSelectScore === "undefined") {
      return;
    }

    onSelectScore(score)();

    const eventAttributes = {
      scoreKey: score,
      isExpanded: activeScore === scoreKey,
    };

    tracking.postEvent({
      eventType: TrackingPipelineEvents.SIDEBAR_SCORE_SELECTED,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.SIDEBAR_SCORE_SELECTED,
      eventAttributes,
    });
  };

  return (
    <div
      className={styles.container}
      data-testid="categories-toggle-slider-score"
      data-score={scoreKey}
      data-is-active={activeScore === scoreKey}
    >
      <Header
        scoreKey={scoreKey}
        scoreValue={scoresData?.[scoreKey]?.value}
        backgroundColor={backgroundColor}
        fillColor={fillColor}
        onClick={handleOnSelectScore(scoreKey)}
      />
      <Content
        isMarkersLoading={isMarkersLoading}
        activeScore={activeScore}
        activeScoreData={activeScoreData}
        markersData={markersData}
      />
    </div>
  );
}
